export const AMAZON_TAG = process.env.REACT_APP_AMAZON_TAG || "jokearmy0f-21";
export const AMAZON_DOMAIN = process.env.REACT_APP_AMAZON_DOMAIN || "amazon.co.uk";
export const ADSENSE_ID = process.env.REACT_APP_ADSENSE_ID || "";

export const amazonLink = (q) =>
  `https://www.${AMAZON_DOMAIN}/s?k=${encodeURIComponent(q)}&tag=${encodeURIComponent(AMAZON_TAG)}`;
